const blockTitle = document.querySelectorAll('.tab-title');
const blockContent = document.querySelectorAll('.tab-content');
const popupLink = document.querySelectorAll(".popup-link");
const popupContainer = document.getElementById("myPopup");
const closePopup = popupContainer.querySelector(".close-popup");
const popIframe = popupContainer.querySelector('iframe');

blockTitle.forEach(title => {
  title.addEventListener('click', e => {
    blockTitle.forEach(theTitle => theTitle.classList.remove('active'));
    blockContent.forEach(mainTab => {
      if (mainTab.id === title.id) {
        mainTab.style.display = "block";
        title.classList.add('active');
      } else {
        mainTab.style.display = "none";
      }
    });
  });
});

popupLink.forEach(a => {
  a.addEventListener('click', e => {
    e.preventDefault();
    popupContainer.style.display = "block";
    popIframe.src = a.dataset.id;
    document.querySelector('body').style.overflowY = 'hidden';
  });
});

closePopup.addEventListener("click", () => {
  popupContainer.style.display = "none";
  document.querySelector('body').style.overflowY = 'scroll';
});
